import {
  CartItemModel,
  plainToInstanceCartItem,
} from '@/entities/cart/model/CartItemModel';
import type { CartProductOptionModel } from '@/entities/cart/model/CartProductOptionModel';
import { CartService, type PatchedCartItemEditRequest } from '@/shared/api';

type UpdateCartItemParams = {
  itemId: number;
  quantity?: number;
  productOptions?: CartProductOptionModel[];
} & PatchedCartItemEditRequest;

type AddToCartItemParams = {
  menu: number;
  product: number;
  quantity: number;
  productOptions?: CartProductOptionModel[];
} & PatchedCartItemEditRequest;

export const mapOptionsForApi = (opts?: CartProductOptionModel[]) =>
  opts?.map((o) => ({
    option_id: o.optionId,
    option_name: o.optionName,
    quantity: o.quantity ?? 1,
    price: o.price ?? 0,
  }));

export class CartApi {
  static async getCart(): Promise<CartItemModel[]> {
    const items = await CartService.v1CartList();
    return items.map(plainToInstanceCartItem);
  }

  static async addToCart(item: AddToCartItemParams): Promise<CartItemModel> {
    const addedItem = await CartService.v1CartCreate({
      body: {
        menu: item.menu,
        product: item.product,
        quantity: item.quantity,
        product_options: mapOptionsForApi(item.productOptions),
      },
    });
    return plainToInstanceCartItem(addedItem);
  }

  static async updateCartItem({
    itemId,
    quantity,
    productOptions,
  }: UpdateCartItemParams): Promise<CartItemModel> {
    const updatedItem = await CartService.v1CartPartialUpdate({
      itemId,
      body: {
        quantity,
        product_options: mapOptionsForApi(productOptions),
      },
    });
    return plainToInstanceCartItem(updatedItem);
  }

  static async deleteCartItem(itemId: number): Promise<void> {
    return CartService.v1CartDestroy2({ itemId });
  }

  static async clearCart(): Promise<void> {
    await CartService.v1CartDestroy();
  }
}
